export const listCodeTypeAll = [
  {
    id: 1,
    code_type: "P",
    code_type_desc: "Pool",
    create_at: "04/03/2024 12:27:23",
    create_by: "FULAN",
    update_at: "04/03/2024 12:27:23",
    update_by: "FULAN",
  },
  {
    id: 2,
    code_type: "O",
    code_type_desc: "Head Office",
    create_at: "04/03/2024 12:27:23",
    create_by: "2024-04-03 12:27:23",
    update_at: "04/03/2024 12:27:23",
    update_by: "FULAN",
  },
  {
    id: 3,
    code_type: "H",
    code_type_desc: "Pangkalan Hotel",
    create_at: "04/03/2024 12:27:23",
    create_by: "2024-04-03 12:27:23",
    update_at: "04/03/2024 12:27:23",
    update_by: "FULAN",
  },
];

export const listAreaAll = [
  {
    id: "AMI",
    name: "Lombok",
  },
  {
    id: "BDO",
    name: "Bandung",
  },
  {
    id: "BPN",
    name: "Balikpapan",
  },
  {
    id: "BTH",
    name: "Batam",
  },
  {
    id: "CLG",
    name: "Cilegon",
  },
  {
    id: "DPS",
    name: "Bali",
  },
  {
    id: "JKT",
    name: "Jakarta",
  },
  {
    id: "JOG",
    name: "Yogyakarta",
  },
  {
    id: "MDC",
    name: "Manado",
  },
  {
    id: "MES",
    name: "Medan",
  },
  {
    id: "MLG",
    name: "Malang",
  },
  {
    id: "PDG",
    name: "Padang",
  },
  {
    id: "PGK",
    name: "Bangka Belitung",
  },
  {
    id: "PKU",
    name: "Pekan baru",
  },
  {
    id: "PLM",
    name: "Palembang",
  },
  {
    id: "SRG",
    name: "Semarang",
  },
  {
    id: "SUB",
    name: "Surabaya",
  },
  {
    id: "UPG",
    name: "Makasar",
  },
];

export const listPoolAll = [
  {
    pool_id: "GR",
    pool_name: "GARUDA",
    area_id: "JKT",
  },
  {
    pool_id: "MN",
    pool_name: "Medan",
    area_id: "MES",
  },
  {
    pool_id: "BC",
    pool_name: "Warung Buncit",
    area_id: "JKT",
  },
  {
    pool_id: "BB",
    pool_name: "Bangka Belitung",
    area_id: "PGK",
  },
  {
    pool_id: "BD",
    pool_name: "BSD",
    area_id: "JKT",
  },
  {
    pool_id: "BM",
    pool_name: "Batam",
    area_id: "BTH",
  },
  {
    pool_id: "BP",
    pool_name: "Balikpapan",
    area_id: "BPN",
  },
  {
    pool_id: "CP",
    pool_name: "Ciputat",
    area_id: "JKT",
  },
  {
    pool_id: "PB",
    pool_name: "Pekanbaru",
    area_id: "PKU",
  },
  {
    pool_id: "CA",
    pool_name: "Cimahi",
    area_id: "BDO",
  },
  {
    pool_id: "CC",
    pool_name: "Cikeas",
    area_id: "JKT",
  },
  {
    pool_id: "CD",
    pool_name: "Cipondoh",
    area_id: "JKT",
  },
  {
    pool_id: "CF",
    pool_name: "CIPULIR",
    area_id: "JKT",
  },
  {
    pool_id: "CK",
    pool_name: "Cakung",
    area_id: "JKT",
  },
  {
    pool_id: "KJ",
    pool_name: "Kramat Jati",
    area_id: "JKT",
  },
  {
    pool_id: "DN",
    pool_name: "Cititrans Surabaya",
    area_id: "SUB",
  },
  {
    pool_id: "DU",
    pool_name: "Cititrans Bandung",
    area_id: "BDO",
  },
  {
    pool_id: "DM",
    pool_name: "Daan Mogot",
    area_id: "JKT",
  },
  {
    pool_id: "PD",
    pool_name: "Puri 2",
    area_id: "JKT",
  },
  {
    pool_id: "SG",
    pool_name: "SEMARANG",
    area_id: "SRG",
  },
  {
    pool_id: "NG",
    pool_name: "Narogong",
    area_id: "JKT",
  },
  {
    pool_id: "GX",
    pool_name: "Galaxy",
    area_id: "JKT",
  },
  {
    pool_id: "CG",
    pool_name: "Cimanggis",
    area_id: "JKT",
  },
  {
    pool_id: "MJ",
    pool_name: "Bali-Majapahit",
    area_id: "DPS",
  },
  {
    pool_id: "PI",
    pool_name: "Puri 1",
    area_id: "JKT",
  },
  {
    pool_id: "PJ",
    pool_name: "Bintaro",
    area_id: "JKT",
  },
  {
    pool_id: "JO",
    pool_name: "Joglo",
    area_id: "JKT",
  },
  {
    pool_id: "KG",
    pool_name: "Kelapa Gading",
    area_id: "JKT",
  },
  {
    pool_id: "KA",
    pool_name: "Kranggan",
    area_id: "JKT",
  },
  {
    pool_id: "KO",
    pool_name: "Kodau",
    area_id: "JKT",
  },
  {
    pool_id: "PL",
    pool_name: "Pondok cabe 2",
    area_id: "JKT",
  },
  {
    pool_id: "JP",
    pool_name: "Japos",
    area_id: "JKT",
  },
  {
    pool_id: "MA",
    pool_name: "Manado",
    area_id: "MDC",
  },
  {
    pool_id: "MK",
    pool_name: "Makassar",
    area_id: "UPG",
  },
  {
    pool_id: "MM",
    pool_name: "Marga Mulya",
    area_id: "JKT",
  },
  {
    pool_id: "MW",
    pool_name: "Margasatwa",
    area_id: "JKT",
  },
  {
    pool_id: "PG",
    pool_name: "Penggilingan",
    area_id: "JKT",
  },
  {
    pool_id: "CO",
    pool_name: "Ciputat 2",
    area_id: "JKT",
  },
  {
    pool_id: "DK",
    pool_name: "Darmokali",
    area_id: "SUB",
  },
  {
    pool_id: "OT",
    pool_name: "Condet",
    area_id: "JKT",
  },
  {
    pool_id: "PM",
    pool_name: "PALEMBANG",
    area_id: "PLM",
  },
  {
    pool_id: "PA",
    pool_name: "Padang",
    area_id: "PDG",
  },
  {
    pool_id: "PC",
    pool_name: "Pondok Kopi",
    area_id: "JKT",
  },
  {
    pool_id: "PH",
    pool_name: "Palmerah",
    area_id: "JKT",
  },
  {
    pool_id: "RD",
    pool_name: "Raden Inten",
    area_id: "JKT",
  },
  {
    pool_id: "HL",
    pool_name: "Halim",
    area_id: "JKT",
  },
  {
    pool_id: "SD",
    pool_name: "Siliwangi depok",
    area_id: "JKT",
  },
  {
    pool_id: "SN",
    pool_name: "Cititrans Semarang",
    area_id: "SRG",
  },
  {
    pool_id: "SY",
    pool_name: "Sutoyo",
    area_id: "JKT",
  },
  {
    pool_id: "JG",
    pool_name: "Yogyakarta",
    area_id: "JOB",
  },
  {
    pool_id: "PT",
    pool_name: "Pondok cabe 1",
    area_id: "JKT",
  },
  {
    pool_id: "TA",
    pool_name: "Bali-Tabanan",
    area_id: "DPS",
  },
  {
    pool_id: "TB",
    pool_name: "Tambun",
    area_id: "JKT",
  },
  {
    pool_id: "BU",
    pool_name: "Bandung",
    area_id: "BDO",
  },
  {
    pool_id: "CJ",
    pool_name: "Cijantung",
    area_id: "JKT",
  },
  {
    pool_id: "JB",
    pool_name: "BALI - Jimbaran",
    area_id: "DPS",
  },
  {
    pool_id: "LS",
    pool_name: "Lakarsantri",
    area_id: "SUB",
  },
  {
    pool_id: "XB",
    pool_name: "Kalibata",
    area_id: "JKT",
  },
  {
    pool_id: "CN",
    pool_name: "CILEGON",
    area_id: "CLG",
  },
  {
    pool_id: "AM",
    pool_name: "Lombok",
    area_id: "AMI",
  },
];

export const listDepartmentAll = [
  {
    id: 1,
    department: "OPS Taxi Reguler",
    department_desc: "Operasi Taxi Reguler",
    department_cost: "OPS",
    is_active: true,
    create_at: "04/25/2024 21:51:27",
    create_by: "Admin",
    update_at: "05/04/2024 07:02:03",
    update_by: "ADMIN",
  },
  {
    id: 2,
    department: "OPS Taxi Executive",
    department_desc: "Operasi Taxi Executive",
    department_cost: "OPS",
    is_active: true,
    create_at: "04/25/2024 21:52:02",
    create_by: "Admin",
    update_at: "04/25/2024 21:53:56",
    update_by: "ADMIN",
  },
  {
    id: 3,
    department: "OPS Limousine Kontrak",
    department_desc: "Operasi Limousine Kontrak",
    department_cost: "OPS",
    is_active: true,
    create_at: "04/25/2024 21:54:27",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 4,
    department: "OPS Limousine Harian",
    department_desc: "Operasi Limousine Harian",
    department_cost: "OPS",
    is_active: true,
    create_at: "04/25/2024 21:54:45",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 5,
    department: "OPS Bus Kontrak",
    department_desc: "Operasi Bus Kontrak",
    department_cost: "OPS",
    is_active: true,
    create_at: "04/25/2024 21:55:03",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 6,
    department: "OPS Bus Harian",
    department_desc: "Operasi Bus Harian",
    department_cost: "OPS",
    is_active: true,
    create_at: "04/25/2024 21:55:24",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 7,
    department: "AK",
    department_desc: "Administrasi Keuangan Pool",
    department_cost: "ADM",
    is_active: true,
    create_at: "04/25/2024 21:55:47",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 8,
    department: "PU",
    department_desc: "Personalia Umum",
    department_cost: "APU",
    is_active: true,
    create_at: "04/25/2024 21:56:09",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 9,
    department: "BKL Taxi Reguler",
    department_desc: "Teknik Bengkel Taxi Meter",
    department_cost: "BKL",
    is_active: true,
    create_at: "04/25/2024 21:56:26",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 10,
    department: "BKL Taxi Executive",
    department_desc: "Teknik Bengkel Taxi Executive",
    department_cost: "BKL",
    is_active: true,
    create_at: "04/25/2024 22:01:08",
    create_by: "Admin",
    update_at: "04/25/2024 22:02:28",
    update_by: "ADMIN",
  },
  {
    id: 11,
    department: "BKL Limousine Kontrak",
    department_desc: "Teknik Bengkel Limousine Kontrak",
    department_cost: "BKL",
    is_active: true,
    create_at: "05/03/2024 15:11:37",
    create_by: "imor",
    update_at: "05/04/2024 07:16:57",
    update_by: "ADMIN",
  },
  {
    id: 12,
    department: "BKL Limousine Harian BC",
    department_desc: "Teknik Bengkel Limousine Harian BC",
    department_cost: "ops ",
    is_active: true,
    create_at: "05/04/2024 07:04:56",
    create_by: "imor",
    update_at: "05/08/2024 07:51:57",
    update_by: "imor",
  },
  {
    id: 13,
    department: "Pool",
    department_desc: "Pool",
    department_cost: "",
    is_active: true,
    create_at: "05/04/2024 07:04:56",
    create_by: "ADMIN",
    update_at: "05/04/2024 07:04:56",
    update_by: "ADMIN",
  },
  {
    id: 14,
    department: "Treasury",
    department_desc: "Kasir Pusat",
    department_cost: "",
    is_active: true,
    create_at: "05/04/2024 07:04:56",
    create_by: "ADMIN",
    update_at: "05/04/2024 07:04:56",
    update_by: "ADMIN",
  },
  {
    id: 15,
    department: "IT",
    department_desc: "Information Technology",
    department_cost: "SIT",
    is_active: true,
    create_at: "05/04/2024 07:04:56",
    create_by: "ADMIN",
    update_at: "05/04/2024 07:04:56",
    update_by: "ADMIN",
  },
  {
    id: 21,
    department: "SKO",
    department_desc: "Staf Khusus Operasional",
    department_cost: "SKO",
    is_active: true,
    create_at: "05/04/2024 07:04:56",
    create_by: "ADMIN",
    update_at: "05/04/2024 07:04:56",
    update_by: "ADMIN",
  },
];

export const columnOptions = [
  { label: "Status bon", value: "status_trx", checked: true },
  { label: "Perpanjangan bon ke", value: "extend_bm", checked: true },
  { label: "No. pengajuan bon", value: "trx_id", checked: true },
  { label: "Tanggal Pengajuan", value: "trx_date", checked: true },
  { label: "Total bon & tipe transaksi", value: "trx_type", checked: true },
  { label: "Deskripsi", value: "trx_text", checked: true },
  { label: "Pemohon & NIP", value: "employee_nip", checked: true },
  { label: "Departemen & jabatan", value: "department", checked: true },
  { label: "Segmen", value: "segment", checked: true },
  { label: "Wilayah & pool", value: "area_name", checked: true },
  { label: "Perusahaan & relasi", value: "company_code", checked: true },
  { label: "Akun GL", value: "trx_code", checked: true },
  { label: "Rekening tujuan", value: "bank_account_name", checked: true },
  { label: "Estimasi tanggal kirim", value: "plan_postdate", checked: true },
  { label: "Lampiran", value: "trx_files", checked: true },
];

export const statusBonOptions = [
  { label: "Lihat semua", value: "" },
  { label: "Diproses", value: "OPEN" },
  { label: "Batal", value: "CANCEL" },
  { label: "Proses transfer", value: "TRANSFER" },
  { label: "Selesai", value: "CLOSE" },
];

export const csvKeys = [
  { title: "No.", field: "no" },
  { title: "Status bon", field: "status_trx", sourceKey: "status_trx" },
  { title: "No. pengajuan bon", field: "trx_id", sourceKey: "trx_id" },
  { title: "Tanggal Pengajuan", field: "trx_date", sourceKey: "trx_date" },
  { title: "Total bon ", field: "amount", sourceKey: "trx_type" },
  { title: "Tipe transaksi", field: "trx_type_description", sourceKey: "trx_type" },
  { title: "Deskripsi", field: "trx_text", sourceKey: "trx_text" },
  { title: "Pemohon ", field: "employee_name", sourceKey: "employee_nip" },
  { title: "NIP Pemohon", field: "employee_nip", sourceKey: "employee_nip" },
  { title: "Departemen", field: "department", sourceKey: "department" },
  { title: "Jabatan", field: "job_title", sourceKey: "department" },
  { title: "Segmen", field: "code_description", sourceKey: "segment" },
  { title: "Wilayah", field: "area_name", sourceKey: "area_name" },
  { title: "Pool", field: "pool_id", sourceKey: "area_name" },
  { title: "Perusahaan", field: "company_code", sourceKey: "company_code" },
  { title: "Perusahaan relasi", field: "company_relation", sourceKey: "company_code" },
  { title: "Akun GL", field: "trx_code", sourceKey: "trx_code" },
  { title: "Jenis transaksi Akun GL", field: "common_trx_type", sourceKey: "trx_code" },
  { title: "Deskripsi Akun GL", field: "trx_desc", sourceKey: "trx_code" },
  { title: "Rekening tujuan", field: "bank_account_name", sourceKey: "bank_account_name" },
  { title: "Estimasi tanggal kirim", field: "plan_postdate", sourceKey: "plan_postdate" },
];
